import { Component } from '@angular/core';
import { Hero } from '../../shared/hero/hero';
import { PriceList } from '../../shared/price-list/price-list';

@Component({
  imports: [Hero, PriceList],
  selector: 'app-pricing',
  styleUrl: './pricing.scss',
  templateUrl: './pricing.html',
})
export class Pricing {}
